// removed by extract-text-webpack-plugin
module.exports = {"row":"_3ZKWlVUAMchBh-GL6DfuHR","townName":"_1v1G2DPpLxSD0dEvW3C_BG","participants":"_2ThGlLsMM2Gsk7OrtqwgYt","level":"_3MT_S_Bg62_Yub7NfYXiJb"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/TownsList/TownsList.css
// module id = 755
// module chunks = 3